<template>
  <div v-if="visivel" class="modal is-active">

    <div class="modal-background" @click="fechar"></div>

    <div class="modal-card">
      <header class="modal-card-head has-background-primary">
        <p class="modal-card-title">
          Associe a Nota ao DRE
        </p>
        <button class="delete" aria-label="close" @click="fechar"></button>
      </header>

      <section class="modal-card-body">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th>Linha do DRE</th>
              <th class="has-text-centered">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(nedr, index) in notasExplicativasDR" :key="nedr.id">
              <td>{{ nedr.demonstracao_resultado_versao_config.descricao }}</td>
              <td class="has-text-centered">
                <button class="button is-small is-info is-outlined" @click="editarNota(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-edit"></i>
                  </span>
                </button>
                <button class="button is-small is-danger is-outlined" @click="excluirNota(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-trash"></i>
                  </span>
                </button>
              </td>
            </tr>

            <tr v-if="notasExplicativasDR.length === 0">
              <td colspan="3" class="has-text-centered has-text-grey">
                Nenhuma fórmula cadastrada para esta linha.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="has-text-right mt-3">
          <button class="button is-success" @click="novaNota" :disabled="habilitaLancamento">
            Cadastrar
          </button>
        </div>

        <br/>

        <div class="card" v-if="habilitaLancamento">
          <header class="card-header">
            <p class="card-header-title">Edição</p>            
          </header>
        
          <div class="card-content">
            <form class="is-fullwidth">
              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">DRE</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="cmbDRE" class="is-fullwidth" :disabled="notaExplicativaDR.id != null"  @change="selectDR()">
                          <option v-for="dr in dres" :key="dr.demonstracao_resultado_versao.id" :value="dr.demonstracao_resultado_versao.id">
                            {{ dr.demonstracao_resultado_versao.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">Linha</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="notaExplicativaDR.demonstracao_resultado_versao_config" class="is-fullwidth" :disabled="cmbDRE == null ">
                          <option v-for="item in itensDRE" :key="item.id" :value="item">
                            {{ item.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <footer class="card-footer">
            <button class="button is-success" @click="save">Salvar</button>
            <button class="button" v-on:click="habilitaLancamento = false">Cancelar</button>
          </footer>
        </div>
      </section>
      
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';

export default {
  name: "notaExplicativaDR",
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    linha: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notaExplicativaDR: {
          id: null,
          demonstracao_resultado_versao_config: null,
          nota_explicativa_nota: null,
      },
      notasExplicativasDR: [],
      dres: [],
      itensDRE: [],
      cmbDRE: null,
      habilitaLancamento: false
    };
  },
  watch: {
    linha(novaLinha) {
      if (novaLinha && novaLinha.id) {
        this.carregarNotas();
      }
    },
    visivel(novoValor) {
      if (novoValor && this.linha?.id) {
        this.carregarNotas();
      }
    }
  },
  methods: {
    clearFields: function() {
      this.notaExplicativaDR = {
        id: null,
        nota_explicativa_nota: parseInt(this.linha.id),
        demonstracao_resultado_versao_config: null,
        index: null
      }
    },

    save: function() {
      var data

      if (this.notaExplicativaDR.demonstracao_resultado_versao_config == null) {
           alert('Linha do DRE não selecionada!')
           return
       }

      data = {id: this.notaExplicativaDR.id,
          demonstracao_resultado_versao_config: this.notaExplicativaDR.demonstracao_resultado_versao_config.id,
          nota_explicativa_notas: this.linha.id
      }

      if (this.notaExplicativaDR.id == null) {
          http.post('/notaExplicativa/adicionarNotasDR', data).then(response =>{
              if (response.data.id != undefined && response.data.id != '') {
                  this.notaExplicativaDR.id = response.data.id
                  this.notasExplicativasDR.push(this.notaExplicativaDR)
                  this.clearFields()
              } else {
                  alert(response.request.responseText)
              }
          }).catch(e => {
              alert(e.response.data);
              return
          })
      } 
      else {
          http.put('/notaExplicativa/editarNotasDR/'+this.notaExplicativaDR.id, data).then(response =>{
              this.notasExplicativasDR[this.notaExplicativaDR.index].id = response.data.id
              this.notasExplicativasDR[this.notaExplicativaDR.index].demonstracao_resultado_versao_config = this.notaExplicativaDR.demonstracao_resultado_versao_config
          }).catch(e => {
              alert(e.response.data);
              return
          })
      }                    

    },

    async carregarNotas() {
      if (!this.linha || !this.linha.id) return;

      try {
        const response = await http.get(`/notaExplicativa/listarNotasDR/`, {
          params: { idNotaExplicativa: parseInt(this.linha.id) }
        });
        this.notasExplicativasDR = response.data.results;
      } catch (error) {
        console.error("Erro ao carregar as associações com o DRE:", error);
        alert("Não foi possível carregar as associações com o DRE. Verifique a linha selecionada ou tente novamente.");
      }
    },

    async novaNota() {
      this.habilitaLancamento = true
      this.clearFields()
    },

    async editarNota(index) {
      this.habilitaLancamento = true
      this.notaExplicativaDR.id = this.notasExplicativasDR[index].id
      this.notaExplicativaDR.nota_explicativa_nota = parseInt(this.linha.id)
      this.notaExplicativaDR.demonstracao_resultado_versao_config = this.notasExplicativasDR[index].demonstracao_resultado_versao_config
      this.cmbDRE = this.notasExplicativasDR[index].demonstracao_resultado_versao_config.demonstracao_resultado_versao.id
      this.selectDR()
      this.notaExplicativaDR.index = index
    },

    async excluirNota(index) {
      if (window.confirm('Confirma exclusão?')) {
        http.delete('/notaExplicativa/excluirNotasDR/'+this.notasExplicativasDR[index].id).then(response =>{
            this.notasExplicativasDR.splice(index, 1)
            if (response.status == 204) {
                alert('Registro excluído!')
            }
        }).catch(e => {
            console.log(e);
        })
      }
    },

    fechar() {
      this.$emit("fechar");
    },

    selectDR: function() {
        http.get('demonstracaoResultadoVersaoConfig/listar/', {params: {
            idDemonstracaoResultadoVersao: this.cmbDRE
        }}).then(response => {
            this.itensDRE = response.data.results
            if (this.itensDRE.length == 0) {
                alert('Não há itens do DRE selecionado cadastrados!')
            }
        })
    },

  },

  mounted() {
    http.get('demonstracaoResultadoVersao/listarDREs/', {
        params: { idVersaoPlanoContas: this.linha.nota_explicativa_periodo.perfil.versao_plano_contas },
      }).then(response => {
        this.dres = response.data.results;
      })
      .catch(error => {
        console.error("Erro ao carregar DREs:", error);
      });

      this.carregarNotas()
  }
};
</script>
